import clsx from 'clsx'
import classes from '../Card.module.scss'
import PropTypes from 'prop-types'

function sizeCalc(long){
    if (long < 3) {
        return "--xl";
    } else if (long < 25) {
        return "--l";
    } else if (long < 51) {
        return "--m";
    } else if (long < 125) {
        return "--s";
    } else {
        return "--xs";
    }
}

export function CardTextImage({ imageSrc, text }) {
    const sizeClass = sizeCalc(text.length)
    return (
        <div className={clsx(classes.card__content, classes["card--text-img"])}>
            <img src={imageSrc} alt='' />
            <div className={clsx(classes["card-text"],classes[sizeClass])}>
                {text}
            </div>
        </div>
    )
}

CardTextImage.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
}